import type { ServiceContent } from './types';
import { buildFaqJsonLd } from '../../../lib/seo';

export const SITE_URL = 'https://www.saharicargo.com';

export const pageUrl = (slug: string) => `${SITE_URL}/services/${slug}`;

/** ISO-2 codes for flagcdn. */
export const COUNTRIES: Array<{ code: string; name: string }> = [
  { code: 'bn', name: 'Brunei' },
  { code: 'bd', name: 'Bangladesh' },
  { code: 'in', name: 'India' },
  { code: 'ph', name: 'Philippines' },
  { code: 'lk', name: 'Sri Lanka' },
  { code: 'my', name: 'Malaysia' },
  { code: 'sg', name: 'Singapore' },
  { code: 'gb', name: 'United Kingdom' },
  { code: 'np', name: 'Nepal' },
  { code: 'pk', name: 'Pakistan' },
];

/** Same order as the Home page "Our Branches" grid. */
export const BRANCH_CITIES = [
  'Jeddah',
  'Makkah',
  'Madinah',
  'Muhayil',
  'Abha',
  'Khamis Mushait',
  'Taif',
  'Yanbu',
  'Rabigh',
  'Jizan',
  'Riyadh',
  'Duba',
];

export const CANNOT_SHIP =
  'For safety and customs reasons, some items cannot be shipped. These include illegal drugs, explosives, weapons, hazardous chemicals, and certain live animals. Please make sure all items in your shipment are declared correctly when booking your cargo.';

/** FAQPage + BreadcrumbList JSON-LD, built from the same data the page shows. */
export const buildJsonLd = (c: ServiceContent) => [
  buildFaqJsonLd(c.faqs),
  {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Home', item: `${SITE_URL}/` },
      { '@type': 'ListItem', position: 2, name: 'Services', item: `${SITE_URL}/services` },
      { '@type': 'ListItem', position: 3, name: c.breadcrumbName, item: pageUrl(c.slug) },
    ],
  },
];
